// extracted by mini-css-extract-plugin
export default {"news_list":"index_news_list_fRslb","box":"index_box_8jRVp","list":"index_list_qDSCg"};